export default __webpack_public_path__ + "static/media/light.880ef520.png";